/// <reference types="react" />

import { Dropdown, IDropdownProps } from "OfficeFabric/Dropdown";
import { css } from "VSSUI/Util";
import * as React from "react";
import { ScreenSize } from "VSS/Core/Util/Screen";
import * as ComponentBase from "VSS/Flux/Component";
import "VSS/LoaderPlugins/Css!TestManagement/Scripts/Scenarios/OnDemandTestRun/Components/ArtifactInputCombo";
import * as Utils_String from "VSS/Utils/String";
import { TooltipHost } from "VSSUI/Tooltip";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";
import { Link } from "VSSUI/Link";
import { Icon, IconSize } from "VSSUI/Icon";

export interface IArtifactInputIconsProps {
    disabled?: boolean;
    iconName: string;
    label: string;
    onClick?: (e?) => void;
}

export interface IArtifactLinkProps extends IArtifactInputIconsProps {
    link?: string;
    role?: string;
    target?: string;
}

export interface IArtifactInputComboProps extends IDropdownProps {
    labelText: string;
    iconButtonPropsList?: IArtifactInputIconsProps[];
}

export class ArtifactInputCombo extends ComponentBase.Component<IArtifactInputComboProps, ComponentBase.State> {
    public render(): JSX.Element {
        const labelText = this.props.labelText ? this.props.labelText : Utils_String.empty;
        return (
            <div className="artifact-container">
                <label className="artifact-combo-label">{labelText}</label>

                <ScreenSizeObserver>
                    {(screenSizeProps: { screenSize: ScreenSize }) => {
                        const isExtraSmalllScreen: boolean = screenSizeProps.screenSize === ScreenSize.xsmall;
                        let containerClassName: string = "artifact-combo-container " + (isExtraSmalllScreen ? "artifact-combo-container-xsmall" : "artifact-combo-container-large");
                        return (
                            <div className={containerClassName}>
                                <div className="artifact-combo-dropdown">
                                    <Dropdown {...this.props} ariaLabel={labelText} />
                                </div>
                                {this.props.iconButtonPropsList && this._getRightLinkIconButtons(this.props.iconButtonPropsList)}
                            </div>
                        );
                    }}
                </ScreenSizeObserver>
            </div>
        );
    }

    private _getRightLinkIconButtons(iconPropsList: IArtifactLinkProps[]) {
        return iconPropsList.map((iconProps, i) => {
            return (
                <TooltipHost content={iconProps.label} key={i}>
                    <div className={css("artifact-input-icon-button")}>
                        <Link
                            disabled={iconProps.disabled}
                            aria-disabled={iconProps.disabled}
                            onClick={iconProps.onClick}
                            ariaLabel={iconProps.label}
                            href={iconProps.link}
                            role={iconProps.role}
                            target={iconProps.target}
                            className={css("artifact-input-icon-link", iconProps.disabled && "artifact-input-icon-disable-link")}
                        >
                            <Icon iconName={iconProps.iconName} size={IconSize.large} className={css("artifact-input-icon")} />
                        </Link>
                    </div>
                </TooltipHost>
            );
        });
    }
}
